import { Box, Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { updateDrug } from "../../../api/group";
import FormDrug from "./formDrug";
import moment from "jalali-moment";

export default function EditDrugModal({
  open,
  setOpen,
  //   date,
  //   setDate,
  dataForm,
  setDataForm,
}) {
  const [dataRowEditDate, setDataRowEditDate] = useState();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90vw",
    // height: "40vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "13px",
    p: 4,
    pt: 10,
  };

  // useEffect(() => {
  //   if (dataForm && !dataRowEditDate) {
  //     const timestamp = moment
  //       .from(`${dataForm?.expireAt}`, "fa", "YYYY/MM/DD")
  //       .valueOf();

  //       // setDataForm({ ...dataForm, expireAt: timestamp });
  //   }
  // }, [dataForm]);

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <FormDrug
          date={dataRowEditDate}
          setDate={setDataRowEditDate}
          dataForm={dataForm}
          setDataForm={setDataForm}
        />
        <Box
          mt="40px"
          gap="10px"
          display={"flex"}
          width="92%"
          justifyContent="end"
        >
          <button
            style={{
              border: "none",
              color: "white",
              background: "var(--emr-primary)",
              width: "100px",
              padding: "10px 0px",
              borderRadius: "10px",
            }}
            onClick={() => {
              if (!dataRowEditDate) {
                const timestamp = moment
                  .from(`${dataForm?.expireAt}`, "fa", "YYYY/MM/DD")
                  .valueOf();
                const updatedDataForm = {
                  ...dataForm,
                  expireAt: timestamp,
                };
                updateDrug(dataForm?.id, updatedDataForm)
                  .then(() => {
                    setOpen(false);
                  })
                  .catch(() => {});
              } else {
                updateDrug(dataForm?.id, dataForm)
                  .then(() => {
                    setOpen(false);
                  })
                  .catch(() => {});
              }
            }}
          >
            ذخیره دارو
          </button>
        </Box>
      </Box>
    </Modal>
  );
}
